import React from 'react';
import { Col } from 'antd';
import { WorkersNumberFormItem } from '@/components/views/Resolution886/components/Form';

export function NumberOfWorkers(): JSX.Element {
	return (
		<Col xs={24}>
			<WorkersNumberFormItem fieldName="workers_number" required={false} />
		</Col>
	);
}
